import OSM from "ol/source/OSM";
import TileLayer from "ol/layer/Tile";
import View from "ol/View";
import Map from "ol/Map";
import Feature from "ol/Feature";
import Point from "ol/geom/Point";
import { fromLonLat, toLonLat } from "ol/proj";
import { useRef, useState, useEffect } from "react";
import { Vector as VectorLayer } from "ol/layer";
import { Vector as VectorSource } from "ol/source";
import { Icon, Style } from "ol/style";

import { initialViewState } from "../../utils";

const start_markerIcon = "/assets/images/icons/marker.png";

const OLMap = ({
  latitude,
  longitude,
  zoom,
  className,
  onChange,
  style = { width: "auto", height: "50px" },
}) => {
  const mapRef = useRef(null);
  const markerSource = useRef(new VectorSource());
  const markerLayer = useRef(
    new VectorLayer({
      source: markerSource.current,
    })
  );

  const [map, setMap] = useState(null);

  useEffect(() => {
    if (!mapRef.current) return;

    const lonlat = [
      longitude || initialViewState.longitude,
      latitude || initialViewState.latitude,
    ];

    // Initial map
    const map = new Map({
      target: mapRef.current,
      layers: [
        new TileLayer({
          source: new OSM(),
        }),
        markerLayer.current,
      ],
      view: new View({
        center: fromLonLat(lonlat),
        zoom: zoom || initialViewState.zoom,
      }),
    });

    // Clear previous markers
    markerSource.current.clear();

    // Add a new marker
    const marker = new Feature({
      geometry: new Point(fromLonLat(lonlat)),
    });
    marker.setStyle(
      new Style({
        image: new Icon({
          anchor: [0.5, 0.5],
          anchorXUnits: "fraction",
          anchorYUnits: "fraction",
          src: start_markerIcon,
          scale: 0.5,
        }),
      })
    );
    markerSource.current.addFeature(marker);

    setMap(map);

    return () => {
      map.dispose();
    };
  }, [latitude, longitude]);

  useEffect(() => {
    if (map && onChange) {
      const handleClick = (evt) => {
        const coordinate = map.getEventCoordinate(evt.originalEvent);
        const originalCoordinate = map.getCoordinateFromPixel(evt.pixel); // Get original coordinate
        const [longitude, latitude] = fromLonLat(coordinate);
        const [originalLongitude, originalLatitude] =
          toLonLat(originalCoordinate); // Convert to original format
        onChange({ latitude, longitude, originalLatitude, originalLongitude });
        // Clear previous markers
        markerSource.current.clear();

        // Add a new marker
        const marker = new Feature({
          geometry: new Point(coordinate),
        });
        marker.setStyle(
          new Style({
            image: new Icon({
              anchor: [0.5, 0.5],
              anchorXUnits: "fraction",
              anchorYUnits: "fraction",
              src: start_markerIcon,
              scale: 0.5,
            }),
          })
        );
        markerSource.current.addFeature(marker);
      };

      map.on("click", handleClick);

      return () => {
        map.un("click", handleClick);
      };
    }
  }, [map, onChange]);

  return <div ref={mapRef} style={style} className={className} />;
};

export default OLMap;
